import { render, staticRenderFns } from "./HomeDetails.vue?vue&type=template&id=0774752a&scoped=true&"
import script from "./HomeDetails.vue?vue&type=script&lang=js&"
export * from "./HomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetails.vue?vue&type=style&index=0&id=0774752a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774752a",
  null
  
)

export default component.exports